const countryNames = {
    US: 'США',
    GB: 'Велика Британія',
    FR: 'Франція',
    DE: 'Німеччина',
    RU: 'Росія',
    IT: 'Італія',
    ES: 'Іспанія',
    PL: 'Польща',
    UA: 'Україна',
    AU: 'Австралія',
    JP: 'Японія',
    KR: 'Південна Корея',
    CN: 'Китай',
    IN: 'Індія',
    MX: 'Мексика',
    BR: 'Бразилія',
    CL: 'Чилі',
    CO: 'Колумбія',
    VE: 'Венесуела',
    MY: 'Малайзія',
    ID: 'Індонезія',
    PH: 'Філіппіни',
    NZ: 'Нова Зеландія',
    SG: 'Сінгапур',
    TH: 'Таїланд',
    VN: 'В\'єтнам',
    TR: 'Туреччина',
    IR: 'Іран',
    MA: 'Марокко',
    DZ: 'Алжир',
    TN: 'Туніс',
    LY: 'Лівія',
    GM: 'Гамбія',
    SN: 'Сенегал',
    MR: 'Мавританія',
    ML: 'Малі',
    GN: 'Гвінея',
    CI: 'Кот-д\'Івуар',
    BF: 'Буркіна-Фасо',
    NE: 'Нігер',
    TG: 'Того',
    BJ: 'Бенін',
    MU: 'Маврикій',
    LR: 'Ліберія',
    SL: 'Сьєрра-Леоне',
    GH: 'Гана',
    NG: 'Нігерія',
    TD: 'Чад',
    CF: 'Центральноафриканська Республіка',
    CM: 'Камерун',
    CV: 'Кабо-Верде',
    ST: 'Сан-Томе і Принсіпі',
    GQ: 'Екваторіальна Гвінея',
    GA: 'Габон',
    CG: 'Конго',
    CD: 'Демократична Республіка Конго',
    AO: 'Ангола',
    GW: 'Гвінея-Бісау',
    IO: 'Британська територія в Індійському океані',
    AC: 'Острів Вознесіння',
    SC: 'Сейшельські Острови',
    SD: 'Судан',
    RW: 'Руанда',
    ET: 'Ефіопія',
    SO: 'Сомалі',
    DJ: 'Джибуті',
    KE: 'Кенія',
    TZ: 'Танзанія',
    UG: 'Уганда',
    BI: 'Бурунді',
    MZ: 'Мозамбік',
    ZM: 'Замбія',
    MG: 'Мадагаскар',
    RE: 'Реюньйон',
    ZW: 'Зімбабве',
    NA: 'Намібія',
    MW: 'Малаві',
    LS: 'Лесото',
    BW: 'Ботсвана',
    SZ: 'Есватіні',
    KM: 'Коморські Острови',
    SH: 'Острів Святої Єлени',
    ER: 'Еритрея',
    AW: 'Аруба',
    FO: 'Фарерські Острови',
    GL: 'Гренландія',
    GI: 'Гібралтар',
    PT: 'Португалія',
    LU: 'Люксембург',
    IE: 'Ірландія',
    IS: 'Ісландія',
    AL: 'Албанія',
    MT: 'Мальта',
    CY: 'Кіпр',
    FI: 'Фінляндія',
    BG: 'Болгарія',
    LT: 'Литва',
    LV: 'Латвія',
    EE: 'Естонія',
    MD: 'Молдова',
    AM: 'Вірменія',
    BY: 'Білорусь',
    AD: 'Андорра',
    MC: 'Монако',
    SM: 'Сан-Марино',
    VA: 'Ватикан',
    RS: 'Сербія',
    ME: 'Чорногорія',
    XK: 'Косово',
    HR: 'Хорватія',
    SI: 'Словенія',
    BA: 'Боснія і Герцеговина',
    MK: 'Північна Македонія',
    CZ: 'Чехія',
    SK: 'Словаччина',
    LI: 'Ліхтенштейн',
    FK: 'Фолклендські Острови',
    BZ: 'Беліз',
    GT: 'Гватемала',
    SV: 'Сальвадор',
    HN: 'Гондурас',
    NI: 'Нікарагуа',
    CR: 'Коста-Рика',
    PA: 'Панама',
    PM: 'Сен-П\'єр і Мікелон',
    HT: 'Гаїті',
    GP: 'Гваделупа',
    BO: 'Болівія',
    GY: 'Гаяна',
    EC: 'Еквадор',
    GF: 'Французька Гвіана',
    PY: 'Парагвай',
    MQ: 'Мартиніка',
    SR: 'Суринам',
    UY: 'Уругвай',
    CW: 'Кюрасао',
    TL: 'Східний Тимор',
    NF: 'Острів Норфолк',
    BN: 'Бруней',
    NR: 'Науру',
    PG: 'Папуа — Нова Гвінея',
    TO: 'Тонга',
    SB: 'Соломонові Острови',
    VU: 'Вануату',
    FJ: 'Фіджі',
    PW: 'Палау',
    WF: 'Уолліс і Футуна',
    CK: 'Острови Кука',
    NU: 'Ніуе',
    AS: 'Американське Самоа',
    WS: 'Самоа',
    KI: 'Кірибаті',
    NC: 'Нова Каледонія',
    TV: 'Тувалу',
    PF: 'Французька Полінезія',
    TK: 'Токелау',
    FM: 'Мікронезія',
    MH: 'Маршаллові Острови',
    KP: 'Північна Корея',
    HK: 'Гонконг',
    MO: 'Макао',
    KH: 'Камбоджа',
    LA: 'Лаос',
    BD: 'Бангладеш',
    TW: 'Тайвань',
    MV: 'Мальдіви',
    LB: 'Ліван',
    JO: 'Йорданія',
    SY: 'Сирія',
    IQ: 'Ірак',
    KW: 'Кувейт',
    SA: 'Саудівська Аравія',
    YE: 'Ємен',
    OM: 'Оман',
    PS: 'Палестина',
    AE: 'ОАЕ',
    IL: 'Ізраїль',
    BH: 'Бахрейн',
    QA: 'Катар',
    BT: 'Бутан',
    MN: 'Монголія',
    NP: 'Непал',
    TJ: 'Таджикистан',
    TM: 'Туркменістан',
    AZ: 'Азербайджан',
    GE: 'Грузія',
    KG: 'Киргизстан',
    UZ: 'Узбекистан',
    PN: 'Піткерн',
    JM: 'Ямайка',
    ZZ: '',
    '??': ''
};

const phoneMasks = [
    { mask: '+{1} (000) 000-0000', startsWith: '1', country: 'US' },
    { mask: '+{44} 00 0000 0000', startsWith: '44', country: 'GB' },
    { mask: '+{33} 0 00 00 00 00', startsWith: '33', country: 'FR' },
    { mask: '+{49} 0000 0000000', startsWith: '49', country: 'DE' },
    { mask: '+{7} 000 000-00-00', startsWith: '7', country: 'RU' },
    { mask: '+{39} 000 000 0000', startsWith: '39', country: 'IT' },
    { mask: '+{34} 000 00 00 00', startsWith: '34', country: 'ES' },
    { mask: '+{48} 000-000-000', startsWith: '48', country: 'PL' },
    { mask: '+{61} 0 000 000 000', startsWith: '61', country: 'AU' },
    { mask: '+{86} 000 0000 0000', startsWith: '86', country: 'CN' },
    { mask: '+{91} 000 000 0000', startsWith: '91', country: 'IN' },
    { mask: '+{52} 000 000 0000', startsWith: '52', country: 'MX' },
    { mask: '+{55} 0000-0000', startsWith: '55', country: 'BR' },
    { mask: '+{56} 000 000 0000', startsWith: '56', country: 'CL' },
    { mask: '+{57} 000 000 0000', startsWith: '57', country: 'CO' },
    { mask: '+{58} 000 000 0000', startsWith: '58', country: 'VE' },
    { mask: '+{60} 0000 0000', startsWith: '60', country: 'MY' },
    { mask: '+{62} 000 0000 0000', startsWith: '62', country: 'ID' },
    { mask: '+{63} 000 000 0000', startsWith: '63', country: 'PH' },
    { mask: '+{64} 000 000 0000', startsWith: '64', country: 'NZ' },
    { mask: '+{65} 0000 0000', startsWith: '65', country: 'SG' },
    { mask: '+{66} 000 000 0000', startsWith: '66', country: 'TH' },
    { mask: '+{81} 000-0000-0000', startsWith: '81', country: 'JP' },
    { mask: '+{82} 000-0000-0000', startsWith: '82', country: 'KR' },
    { mask: '+{84} 000 000 0000', startsWith: '84', country: 'VN' },
    { mask: '+{90} 000 000 00 00', startsWith: '90', country: 'TR' },
    { mask: '+{98} 0000 0000 0000', startsWith: '98', country: 'IR' },
    { mask: '+{212} 000 000 0000', startsWith: '212', country: 'MA' },
    { mask: '+{213} 000 000 0000', startsWith: '213', country: 'DZ' },
    { mask: '+{216} 000 000 0000', startsWith: '216', country: 'TN' },
    { mask: '+{218} 000 000 0000', startsWith: '218', country: 'LY' },
    { mask: '+{220} 000 000 0000', startsWith: '220', country: 'GM' },
    { mask: '+{221} 000 000 0000', startsWith: '221', country: 'SN' },
    { mask: '+{222} 000 000 0000', startsWith: '222', country: 'MR' },
    { mask: '+{223} 000 000 0000', startsWith: '223', country: 'ML' },
    { mask: '+{224} 000 000 0000', startsWith: '224', country: 'GN' },
    { mask: '+{225} 000 000 0000', startsWith: '225', country: 'CI' },
    { mask: '+{226} 000 000 0000', startsWith: '226', country: 'BF' },
    { mask: '+{227} 000 000 0000', startsWith: '227', country: 'NE' },
    { mask: '+{228} 000 000 0000', startsWith: '228', country: 'TG' },
    { mask: '+{229} 000 000 0000', startsWith: '229', country: 'BJ' },
    { mask: '+{230} 000 000 0000', startsWith: '230', country: 'MU' },
    { mask: '+{231} 000 000 0000', startsWith: '231', country: 'LR' },
    { mask: '+{232} 000 000 0000', startsWith: '232', country: 'SL' },
    { mask: '+{233} 000 000 0000', startsWith: '233', country: 'GH' },
    { mask: '+{234} 000 000 0000', startsWith: '234', country: 'NG' },
    { mask: '+{235} 000 000 0000', startsWith: '235', country: 'TD' },
    { mask: '+{236} 000 000 0000', startsWith: '236', country: 'CF' },
    { mask: '+{237} 000 000 0000', startsWith: '237', country: 'CM' },
    { mask: '+{238} 000 000 0000', startsWith: '238', country: 'CV' },
    { mask: '+{239} 000 000 0000', startsWith: '239', country: 'ST' },
    { mask: '+{240} 000 000 0000', startsWith: '240', country: 'GQ' },
    { mask: '+{241} 000 000 0000', startsWith: '241', country: 'GA' },
    { mask: '+{242} 000 000 0000', startsWith: '242', country: 'CG' },
    { mask: '+{243} 000 000 0000', startsWith: '243', country: 'CD' },
    { mask: '+{244} 000 000 0000', startsWith: '244', country: 'AO' },
    { mask: '+{245} 000 000 0000', startsWith: '245', country: 'GW' },
    { mask: '+{246} 000 000 0000', startsWith: '246', country: 'IO' },
    { mask: '+{247} 000 000 0000', startsWith: '247', country: 'AC' },
    { mask: '+{248} 000 000 0000', startsWith: '248', country: 'SC' },
    { mask: '+{249} 000 000 0000', startsWith: '249', country: 'SD' },
    { mask: '+{250} 000 000 0000', startsWith: '250', country: 'RW' },
    { mask: '+{251} 000 000 0000', startsWith: '251', country: 'ET' },
    { mask: '+{252} 000 000 0000', startsWith: '252', country: 'SO' },
    { mask: '+{253} 000 000 0000', startsWith: '253', country: 'DJ' },
    { mask: '+{254} 000 000 0000', startsWith: '254', country: 'KE' },
    { mask: '+{255} 000 000 0000', startsWith: '255', country: 'TZ' },
    { mask: '+{256} 000 000 0000', startsWith: '256', country: 'UG' },
    { mask: '+{257} 000 000 0000', startsWith: '257', country: 'BI' },
    { mask: '+{258} 000 000 0000', startsWith: '258', country: 'MZ' },
    { mask: '+{260} 000 000 0000', startsWith: '260', country: 'ZM' },
    { mask: '+{261} 000 000 0000', startsWith: '261', country: 'MG' },
    { mask: '+{262} 000 000 0000', startsWith: '262', country: 'RE' },
    { mask: '+{263} 000 000 0000', startsWith: '263', country: 'ZW' },
    { mask: '+{264} 000 000 0000', startsWith: '264', country: 'NA' },
    { mask: '+{265} 000 000 0000', startsWith: '265', country: 'MW' },
    { mask: '+{266} 000 000 0000', startsWith: '266', country: 'LS' },
    { mask: '+{267} 000 000 0000', startsWith: '267', country: 'BW' },
    { mask: '+{268} 000 000 0000', startsWith: '268', country: 'SZ' },
    { mask: '+{269} 000 000 0000', startsWith: '269', country: 'KM' },
    { mask: '+{290} 000 0000', startsWith: '290', country: 'SH' },
    { mask: '+{291} 000 0000', startsWith: '291', country: 'ER' },
    { mask: '+{297} 000 0000', startsWith: '297', country: 'AW' },
    { mask: '+{298} 000 0000', startsWith: '298', country: 'FO' },
    { mask: '+{299} 00 00 00', startsWith: '299', country: 'GL' },
    { mask: '+{350} 000 0000', startsWith: '350', country: 'GI' },
    { mask: '+{351} 000 000 000', startsWith: '351', country: 'PT' },
    { mask: '+{352} 000 000 000', startsWith: '352', country: 'LU' },
    { mask: '+{353} 00 000 0000', startsWith: '353', country: 'IE' },
    { mask: '+{354} 000 0000', startsWith: '354', country: 'IS' },
    { mask: '+{355} 000 000 0000', startsWith: '355', country: 'AL' },
    { mask: '+{356} 0000 0000', startsWith: '356', country: 'MT' },
    { mask: '+{357} 000 000000', startsWith: '357', country: 'CY' },
    { mask: '+{358} 00 000 0000', startsWith: '358', country: 'FI' },
    { mask: '+{359} 000 000 000', startsWith: '359', country: 'BG' },
    { mask: '+{370} 000 00000', startsWith: '370', country: 'LT' },
    { mask: '+{371} 000 0000', startsWith: '371', country: 'LV' },
    { mask: '+{372} 0000 0000', startsWith: '372', country: 'EE' },
    { mask: '+{373} 000 00000', startsWith: '373', country: 'MD' },
    { mask: '+{374} 000 000000', startsWith: '374', country: 'AM' },
    { mask: '+{375} 00 000 00 00', startsWith: '375', country: 'BY' },
    { mask: '+{376} 000 000', startsWith: '376', country: 'AD' },
    { mask: '+{377} 000 000 000', startsWith: '377', country: 'MC' },
    { mask: '+{378} 000 000 000', startsWith: '378', country: 'SM' },
    { mask: '+{379} 000 000 000', startsWith: '379', country: 'VA' },
    { mask: '+{380} 00 000 00 00', startsWith: '380', country: 'UA' },
    { mask: '+{381} 00 000 0000', startsWith: '381', country: 'RS' },
    { mask: '+{382} 000 000 000', startsWith: '382', country: 'ME' },
    { mask: '+{383} 000 000 000', startsWith: '383', country: 'XK' },
    { mask: '+{385} 00 000 0000', startsWith: '385', country: 'HR' },
    { mask: '+{386} 0 000 0000', startsWith: '386', country: 'SI' },
    { mask: '+{387} 00 000 000', startsWith: '387', country: 'BA' },
    { mask: '+{389} 0 000 0000', startsWith: '389', country: 'MK' },
    { mask: '+{420} 000 000 000', startsWith: '420', country: 'CZ' },
    { mask: '+{421} 000 000 000', startsWith: '421', country: 'SK' },
    { mask: '+{423} 000 0000', startsWith: '423', country: 'LI' },
    { mask: '+{500} 0000', startsWith: '500', country: 'FK' },
    { mask: '+{501} 000 0000', startsWith: '501', country: 'BZ' },
    { mask: '+{502} 0000 0000', startsWith: '502', country: 'GT' },
    { mask: '+{503} 0000 0000', startsWith: '503', country: 'SV' },
    { mask: '+{504} 0000 0000', startsWith: '504', country: 'HN' },
    { mask: '+{505} 0000 0000', startsWith: '505', country: 'NI' },
    { mask: '+{506} 0000 0000', startsWith: '506', country: 'CR' },
    { mask: '+{507} 0000 0000', startsWith: '507', country: 'PA' },
    { mask: '+{508} 000 0000', startsWith: '508', country: 'PM' },
    { mask: '+{509} 00 00 00 00', startsWith: '509', country: 'HT' },
    { mask: '+{590} 000 000000', startsWith: '590', country: 'GP' },
    { mask: '+{591} 0 000 0000', startsWith: '591', country: 'BO' },
    { mask: '+{592} 000 0000', startsWith: '592', country: 'GY' },
    { mask: '+{593} 0 000 0000', startsWith: '593', country: 'EC' },
    { mask: '+{594} 000 000000', startsWith: '594', country: 'GF' },
    { mask: '+{595} 0 000 0000', startsWith: '595', country: 'PY' },
    { mask: '+{596} 000 000000', startsWith: '596', country: 'MQ' },
    { mask: '+{597} 000 0000', startsWith: '597', country: 'SR' },
    { mask: '+{598} 0000 0000', startsWith: '598', country: 'UY' },
    { mask: '+{599} 0000 0000', startsWith: '599', country: 'CW' },
    { mask: '+{670} 000 0000', startsWith: '670', country: 'TL' },
    { mask: '+{672} 000 0000', startsWith: '672', country: 'NF' },
    { mask: '+{673} 000 0000', startsWith: '673', country: 'BN' },
    { mask: '+{674} 000 0000', startsWith: '674', country: 'NR' },
    { mask: '+{675} 000 00000', startsWith: '675', country: 'PG' },
    { mask: '+{676} 000 0000', startsWith: '676', country: 'TO' },
    { mask: '+{677} 000 0000', startsWith: '677', country: 'SB' },
    { mask: '+{678} 000 0000', startsWith: '678', country: 'VU' },
    { mask: '+{679} 000 0000', startsWith: '679', country: 'FJ' },
    { mask: '+{680} 000 0000', startsWith: '680', country: 'PW' },
    { mask: '+{681} 000 0000', startsWith: '681', country: 'WF' },
    { mask: '+{682} 000 0000', startsWith: '682', country: 'CK' },
    { mask: '+{683} 000 0000', startsWith: '683', country: 'NU' },
    { mask: '+{684} 000 0000', startsWith: '684', country: 'AS' },
    { mask: '+{685} 000 0000', startsWith: '685', country: 'WS' },
    { mask: '+{686} 000 0000', startsWith: '686', country: 'KI' },
    { mask: '+{687} 00 00 00', startsWith: '687', country: 'NC' },
    { mask: '+{688} 000 0000', startsWith: '688', country: 'TV' },
    { mask: '+{689} 00 00 00', startsWith: '689', country: 'PF' },
    { mask: '+{690} 0000', startsWith: '690', country: 'TK' },
    { mask: '+{691} 000 000', startsWith: '691', country: 'FM' },
    { mask: '+{692} 000 000', startsWith: '692', country: 'MH' },
    { mask: '+{850} 000 0000', startsWith: '850', country: 'KP' },
    { mask: '+{852} 0000 0000', startsWith: '852', country: 'HK' },
    { mask: '+{853} 0000 0000', startsWith: '853', country: 'MO' },
    { mask: '+{855} 00 000 000', startsWith: '855', country: 'KH' },
    { mask: '+{856} 0 000 0000', startsWith: '856', country: 'LA' },
    { mask: '+{870} 000 0000', startsWith: '870', country: 'PN' },
    { mask: '+{876} 000 0000', startsWith: '876', country: 'JM' },
    { mask: '+{878} 000 0000', startsWith: '878', country: 'US' },
    { mask: '+{879} 000 0000', startsWith: '879', country: 'ZZ' },
    { mask: '+{880} 0000 000000', startsWith: '880', country: 'BD' },
    { mask: '+{886} 000 000000', startsWith: '886', country: 'TW' },
    { mask: '+{960} 000 0000', startsWith: '960', country: 'MV' },
    { mask: '+{961} 00 000 000', startsWith: '961', country: 'LB' },
    { mask: '+{962} 000 000 000', startsWith: '962', country: 'JO' },
    { mask: '+{963} 000 000 000', startsWith: '963', country: 'SY' },
    { mask: '+{964} 0000 000000', startsWith: '964', country: 'IQ' },
    { mask: '+{965} 000 000 000', startsWith: '965', country: 'KW' },
    { mask: '+{966} 0000 000000', startsWith: '966', country: 'SA' },
    { mask: '+{967} 000 000 000', startsWith: '967', country: 'YE' },
    { mask: '+{968} 000 000 000', startsWith: '968', country: 'OM' },
    { mask: '+{970} 000 000 000', startsWith: '970', country: 'PS' },
    { mask: '+{971} 00 000 0000', startsWith: '971', country: 'AE' },
    { mask: '+{972} 000 000 000', startsWith: '972', country: 'IL' },
    { mask: '+{973} 0000 0000', startsWith: '973', country: 'BH' },
    { mask: '+{974} 0000 0000', startsWith: '974', country: 'QA' },
    { mask: '+{975} 000 0000', startsWith: '975', country: 'BT' },
    { mask: '+{976} 0000 0000', startsWith: '976', country: 'MN' },
    { mask: '+{977} 0000 0000', startsWith: '977', country: 'NP' },
    { mask: '+{992} 000 000 0000', startsWith: '992', country: 'TJ' },
    { mask: '+{993} 000 000000', startsWith: '993', country: 'TM' },
    { mask: '+{994} 00 000 0000', startsWith: '994', country: 'AZ' },
    { mask: '+{995} 0 000 0000', startsWith: '995', country: 'GE' },
    { mask: '+{996} 000 000 000', startsWith: '996', country: 'KG' },
    { mask: '+{998} 00 000 0000', startsWith: '998', country: 'UZ' },
    { mask: '+{999} 000 000 000', startsWith: '999', country: 'ZZ' },
    { mask: '+0000000000000', startsWith: '', country: '??' }
];